import { render, staticRenderFns } from "./iDSNetworkError.vue?vue&type=template&id=70e0fe7f"
import script from "./iDSNetworkError.vue?vue&type=script&lang=js"
export * from "./iDSNetworkError.vue?vue&type=script&lang=js"
import style0 from "./iDSNetworkError.vue?vue&type=style&index=0&id=70e0fe7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports